import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { NgClass, NgFor } from "@angular/common";
import { NgxPaginationModule } from "ngx-pagination";

@Component({
    selector: 'kb-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgxPaginationModule,
        NgClass,
        NgFor,
    ],
})
export class PaginationComponent {
    @Input() id: string;
    @Input() maxSize: number;
    @Output() pageChange = new EventEmitter<number>();
    @Output() pageBoundsCorrection = new EventEmitter<number>();
}
